import React, { useEffect, useState } from 'react'
import PageContainer from 'src/components/container/PageContainer'
import Products from './Products'
import { Box, Grid } from '@mui/material'
import { useMain } from '../hooks/useMain'
import ShowLoader from 'src/components/CustomComponents/ShowLoader'
import DashboardCard2 from 'src/components/shared/DashboardCard2'

const data = [
    { productName: 'Product A', mrp: 10, volume: '100ml', reward: 5, barcode: '123456789' },
    { productName: 'Product B', mrp: 15, volume: '200ml', reward: 7, barcode: '987654321' },
    { productName: 'Product C', mrp: 20, volume: '150ml', reward: 4, barcode: '456789123' },
    { productName: 'Product D', mrp: 25, volume: '250ml', reward: 8, barcode: '321654987' },
    { productName: 'Product E', mrp: 30, volume: '180ml', reward: 6, barcode: '789123456' }
];

const AllProducts = () => {
    const [data, setData] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [activePage, setActivePage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);

    const { fetchAllProducts } = useMain();

    const getData = async () => {
        setShowLoader(true);
        const res = await fetchAllProducts({ limit: 10, page: activePage });
       
        setData(res?.data?.result);
        setTotalPage(1);
        setShowLoader(false);
    }

    useEffect(() => {
        getData();

        return () => { }
    }, []);

    return (
        <PageContainer title="Manage Product" description="this contains all data">
            <DashboardCard2 title="Manage Products">
                <Box>
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={12}>
                            <Products data={data} setData={setData} />
                        </Grid>
                    </Grid>
                </Box>
                {showLoader && <ShowLoader value={showLoader} />}
            </DashboardCard2>
        </PageContainer>
    )
}

export default AllProducts
